import React from "react";
import { Card, CardContent, Typography, Box } from "@mui/material";
import RoomOutlinedIcon from "@mui/icons-material/RoomOutlined";
import Locations from "./Locations";

const MemberLocationsCard = () => (
  <Box sx={{ mt: 5 }}>
    <Card
      sx={{
        borderRadius: "18px",
        boxShadow: "0 8px 24px rgba(0,0,0,0.10)",
        backgroundColor: "rgba(255,255,255,0.96)",
        backdropFilter: "blur(6px)",
        border: "1px solid rgba(47,99,173,0.08)",
        overflow: "hidden",
      }}
    >
      <CardContent sx={{ p: 3 }}>
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.25,
            mb: 2,
          }}
        >
          <Box
            sx={{
              width: 42,
              height: 42,
              borderRadius: "12px",
              background: "rgba(47,99,173,0.10)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <RoomOutlinedIcon sx={{ fontSize: 22, color: "#2f63ad" }} />
          </Box>

          <Box>
            <Typography
              variant="h6"
              sx={{
                color: "#223142",
                fontWeight: 700,
                letterSpacing: "0.2px",
                lineHeight: 1.2,
              }}
            >
              Member Locations
            </Typography>
         <Typography variant="caption" sx={{ color: "#7a8696" }}>
  Active Work Orders Map
</Typography>
          </Box>
        </Box>

        {/* Map container */}
        <Box
          sx={{
            height: 420,
            borderRadius: "14px",
            backgroundColor: "#fbfcfe",
            border: "1px solid #eef2f7",
            overflow: "hidden",
          }}
        >
          <Locations />
        </Box>
      </CardContent>
    </Card>
  </Box>
);

export default MemberLocationsCard;